// frontend/src/components/AuthInitializer.tsx
import { useAuth } from "../context/AuthContext";
import styles from "./authInitilizer.module.css";
export const AuthInitializer = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { initialized } = useAuth();

  if (!initialized) {
    return (
      <div>
        <div className={styles["preloader-plus"]}>
          <img
            src="/images/scadellogosvg.png"
            className={styles["preloader-custom-img"]}
            alt="scadelLogo"
          />
        </div>
      </div>
    );
  }

  return <>{children}</>;
};
